








import { Component, Vue, Prop } from 'vue-property-decorator';
import { MultiFileUploaderImageModule } from 'client-website-ts-library/types/Forms/FieldTypes';

@Component
export default class FormMultiFileUploaderImageModule extends Vue {
  @Prop()
  private readonly def!: MultiFileUploaderImageModule;

  private uploadFiles(capture: boolean): void {
    const fi = document.createElement('input') as HTMLInputElement;

    fi.type = 'file';
    fi.accept = this.def.AcceptableMIMETypes.join(',');
    fi.multiple = true;
    fi.style.display = 'none';

    if (capture) {
      fi.setAttribute('capture', 'envionment');
    }

    fi.onchange = () => {
      if (fi.files!.length) {
        this.$emit('add_files', fi.files!);

        fi.remove();
      }
    };

    fi.onblur = () => {
      setTimeout(() => {
        fi.remove();
      }, 100);
    };

    document.body.appendChild(fi);

    fi.click();
  }
}
